
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/filter/[[...uri]]",
      function () {
        return require("private-next-pages/media/filter/[[...uri]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/filter/[[...uri]]"])
      });
    }
  